<template>
    <div class="client-create">
        <!-- number -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Number</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="clientNumber" class="input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="clientName" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- game categories -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Game categories</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                            <div
                                class="menu-item"
                                v-for="category in categories"
                                :key="category.name"
                            >
                                {{ category.name }}
                                <input
                                    v-model="category.enabled"
                                    type="checkbox"
                                    class="checkbox"
                                />
                            </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- game providers -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Game providers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                            <div
                                class="menu-item"
                                v-for="provider in providers"
                                :key="provider.name"
                            >
                                {{ provider.name }}
                                <input
                                    v-model="provider.enabled"
                                    type="checkbox"
                                    class="checkbox"
                                />
                            </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- hdraces -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Horses 6</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="hdraces[0]" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Horses 8</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="hdraces[1]" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Dogs 6</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="hdraces[2]" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Dogs 8</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="hdraces[3]" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field">
            <div class="control">
                <button class="button is-primary" @click="create()">Create</button>
            </div>
        </div>
    </div>
</template>
<script>
import clientService from '../../services/client.service';

export default {
    name: 'client-create',
    data() {
        return {
            clientNumber: 0,
            clientName: '',
            categories: [
                { name: 'slots', enabled: false },
                { name: 'video-games', enabled: false },
                { name: 'virtual-sports', enabled: false },
                { name: 'sport', enabled: false },
                { name: 'live-casino', enabled: false },
                { name: 'covid', enabled: false },
                { name: 'softgamings', enabled: false }
            ],
            providers: [
                { name: 'redpipe', enabled: false },
                { name: 'flg', enabled: false },
                { name: 'hdraces', enabled: false },
                { name: 'bk', enabled: false },
                { name: 'tvbet', enabled: false },
                { name: 'covid', enabled: false },
                { name: 'softgamings', enabled: false },
                { name: 'aviatrix', enabled: false }
            ],
            hdraces: ['_horses_6', '_horses_8', '_greyhounds_6', '_greyhounds_8']
        };
    },
    methods: {
        async create() {
            let cat = this.categories.filter(c => c.enabled).map(c => c.name);
            let prov = this.providers.filter(c => c.enabled).map(p => p.name);
            let hdr = this.hdraces.filter(f => typeof f === "string");
            await clientService.create(
                {
                    number: this.clientNumber,
                    name: this.clientName,
                    categories: cat,
                    providers: prov,
                    hdraces: hdr
                }
            );
            this.$router.push({ name: 'dashboard' });
        }
    }
};
</script>
<style lang="scss">
.client-create {
    .menu-item {
        margin-bottom: .32rem;
        padding: .4rem .8rem;
        width: 240px;
        border: 1px solid #666;
        border-radius: .2rem;
        background-color: #333;

        .icon {
            margin-right: .2rem;
        }

        .checkbox {
            float: right;
        }
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/create.vue